import React from 'react'

const UserAltIcon = props => (
  <svg viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7065 13.6068C15.125 12.1632 16 10.1838 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 10.1854 0.87632 12.1662 2.29674 13.6101C2.65745 11.5611 4.09503 9.88321 6.00422 9.18184C5.36827 8.6256 4.9666 7.80816 4.9666 6.8969C4.9666 5.221 6.32518 3.86242 8.00108 3.86242C9.67698 3.86242 11.0356 5.221 11.0356 6.8969C11.0356 7.80793 10.6341 8.62519 9.99841 9.18142C11.9072 9.88217 13.3447 11.5589 13.7065 13.6068Z"
      fill="#596B7E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7065 13.6068C15.125 12.1632 16 10.1838 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 10.1854 0.87632 12.1662 2.29674 13.6101C2.65745 11.5611 4.09503 9.88321 6.00422 9.18184C5.36827 8.6256 4.9666 7.80816 4.9666 6.8969C4.9666 5.221 6.32518 3.86242 8.00108 3.86242C9.67698 3.86242 11.0356 5.221 11.0356 6.8969C11.0356 7.80793 10.6341 8.62519 9.99841 9.18142C11.9072 9.88217 13.3447 11.5589 13.7065 13.6068Z"
      fill="url(#paint0_radial)"
      fillOpacity="0.2"
    />
    <defs>
      <radialGradient
        id="paint0_radial"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(2.76298 5.0411) rotate(64.4602) scale(12.147 12.1464)"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
)

export default UserAltIcon
